import { useMemo } from "react";
import { GoabContainer, GoabSpacer } from "@abgov/react-components";

import { useSessionManagement, useGenerationForm } from "../../hooks";

import CanadaAddress from "../../../../../MPP-Common-SPA/Widgets/AddressComplete/CanadaAddress";
import CanadaPostAddressComplete from "../../../../../MPP-Common-SPA/Widgets/AddressComplete/CanadaPostAddressComplete";

export const MailingAddressSection = () => {
  const { form, fieldValues, fieldErrors, fieldTouches } = useGenerationForm(
    "PersonalInformation"
  );

  const { getResourceValue } = useSessionManagement();

  // Need to use a dummy form to enable compatability with CanadaAddress, which
  // appears to be intended to interact with the base address of the logged
  // in user or possibly the step context in public portal whereas it is
  // nested in the applicationData.
  // The dummy form essentially maps the personal address section to a flat
  // structure alike public portals user/step context.

  const addressForm = useMemo(
    () => ({
      values: {
        streetAddressLine1: fieldValues.streetAddressLine1 || "",
        streetAddressLine2: fieldValues.streetAddressLine2 || "",
        locality: fieldValues.locality || "",
        province: fieldValues.province || "",
        postalCode: fieldValues.postalCode || "",
      },
      errors: {
        streetAddressLine1: fieldErrors.streetAddressLine1,
        streetAddressLine2: fieldErrors.streetAddressLine2,
        locality: fieldErrors.locality,
        province: fieldErrors.province,
        postalCode: fieldErrors.postalCode,
      },
      touched: {
        streetAddressLine1: fieldTouches.streetAddressLine1,
        streetAddressLine2: fieldTouches.streetAddressLine2,
        locality: fieldTouches.locality,
        province: fieldTouches.province,
        postalCode: fieldTouches.postalCode,
      },
      // Needed for the internal CanadaAddress logic to work
      setFieldValue: (name: any, value: any) => {
        form.setFieldValue(`PersonalInformation.${name}`, value);
      },
      setFieldTouched: (name: any, touched: boolean | undefined) => {
        form.setFieldTouched(`PersonalInformation.${name}`, touched);
      },
      dirty: form.dirty,
    }),
    [fieldValues, fieldErrors, fieldTouches, form]
  );

  return (
    <>
      <GoabContainer accent="thin">
        <h3>
          {getResourceValue({
            key: "RESOURCES@review.label.mailingAddress",
          })}
        </h3>

        <GoabSpacer vSpacing="l" />
        <CanadaPostAddressComplete></CanadaPostAddressComplete>
        <CanadaAddress
          form={addressForm}
          getResourceValue={getResourceValue}
          provinceCodes="AB"
          context={{
            stepData: {
              streetAddressLine1: fieldValues.streetAddressLine1,
              streetAddressLine2: fieldValues.streetAddressLine2,
              locality: fieldValues.locality,
              province: fieldValues.province,
              postalCode: fieldValues.postalCode,
            },
          }}
          setFormData={(updatedValues: any) => {
            Object.entries(updatedValues).forEach(([key, value]) => {
              if (value !== undefined) {
                form.setFieldValue(`PersonalInformation.${key}`, value);
              }
            });
          }}
        ></CanadaAddress>
      </GoabContainer>
      <GoabSpacer vSpacing="2xs" />
    </>
  );
};
